/* src/app/common/mpos-forms/components/mpos-input/mpos-input.component.scss */
mpos-input {
  display: flex;
}
mpos-input nz-form-item {
  display: flex;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1mb3Jtcy9jb21wb25lbnRzL21wb3MtaW5wdXQvbXBvcy1pbnB1dC5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsibXBvcy1pbnB1dCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICAvLyBmbGV4OiAxIDEgMCU7XG4gICAgbnotZm9ybS1pdGVtIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjtBQUFBO0FBQ0ksV0FBQTs7QUFFQSxXQUFBO0FBQ0ksV0FBQTtBQUNBLFNBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
